import React, { Component } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );
  }
}

export default class Responsive extends Component {
  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      autoPlay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 5000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div className='slick slick-single-line'>
        <Slider {...settings}>

        <CustomSlide className='itm' index={1}>
            <div className='bg'>
              <img
                src="./img/feature/blood.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='name'>Functional Blood Testing</div>
              <div className='content'>
              Comprehensive functional bloodwork to uncover root causes and optimize your health
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={1}>
            <div className='bg'>
              <img
                src="./img/feature/img1.jpg"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='name'>Nutrition</div>
              <div className='content'>
                Explore the therapeutic potential of food
                as a form of medicine through the careful
                consideration of timing, preparation methods, 
                precise dosing, and integration with appropriate
                supplementation.
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={2}>
            <div className='bg'>
              <img
                src="./img/feature/img2.jpg"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='name'>Lifestyle</div>
              <div className='content'>
                Discover how to transform your everyday behaviours into 
                strategies that foster long-term health & well-being
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/feature/img3.jpg"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='name'>Botanicals</div>
              <div className='content'>
                Enhance your well-being through utilizing
                evidence-based therapeutic properties of 
                botanical remedies.
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={4}>
            <div className='bg'>
              <img
                src="./img/feature/Acu.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='name'>Acupuncture</div>
              <div className='content'>
                Experience pain relief, energy rebalance, and muscle relaxation, stemming from Traditional Asian Medicine and backed by modern sceince research.
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={4}>
            <div className='bg'>
              <img
                src="./img/feature/img5.jpg"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='name'>IV Therapy</div>
              <div className='content'>
                Support your overall health and well-being
                through adminstration of essential nutritients
                directly into the bloodstream. This bypasses the 
                digestive system so no nutrients are lost.
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={4}>
            <div className='bg'>
              <img
                src="./img/feature/img4.jpg"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='name'>Injections</div>
              <div className='content'>
                Direct adminstrtion into the muscle
                facillitating rapid therapeutic effects
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={4}>
            <div className='bg'>
              <img
                src="./img/feature/img6.jpg"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='name'>Personal Training</div>
              <div className='content'>
                Customized individual fitness programs to help you achieve health and fitness goals with 1-on-1 guidance.
              </div>
            </div>
          </CustomSlide>
        </Slider>
      </div>
    );
  }
}
